<script>
import lang from 'element-ui/lib/locale/lang/da'
import locale from 'element-ui/lib/locale'
locale.use(lang)
export default {
  name: 'contracts',
  components: {
  },
  data () {
    return {
      search: '',
      tableData: [{
        date: '2016-05-03',
        name: 'Alexander Poindexter Aloysius Mountbatten',
        docs: '3',
        type: 'A/B Bygge',
        project: 'New Terrace',
        wallet: '123.456,00 kr',
        status: 'Signed',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-02',
        name: 'Dick',
        docs: '3',
        type: 'A/B Bygge',
        project: 'New Terrace',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-04',
        name: 'Tom',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Pending',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-01',
        name: 'Harry',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-08',
        name: 'George',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-06',
        name: 'John',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Draft',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-07',
        name: 'Leo',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }]
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
  }
}
</script>
<template>
  <div class="animated fadeIn py3 px3">
    <div class="clearfix gibson pl4 mt3 mb2" v-if="!showMobile">
      <div class="col-12 ml3 px0">
        <p class="h4 semi-bold line-height-2 my2 darkblue">
          Kontrakter
        </p>
      </div>
      <!-- status items and search -->
      <div class="clearfix col-12 px0 flex justify-start items-center">
        <div class="col-5 pl3 flex justify-start items-center">
          <div class="yellow-background darkblue pt1 pr2 flex justify-start items-center mr1">
            <span class="h5 regular mx2">17</span>
            <span class="h6 regular mb1">I forhandling</span>
          </div>
          <div class="darkblue-background pt1 pr2 white flex flex justify-start items-center mr1">
            <span class="h5 regular mx2">2</span>
            <span class="h6 regular mx2">Underskrevet</span>
          </div>
          <div class="green-background white pt1 pr2 flex justify-start items-center">
            <span class="h5 regular mx2">8</span>
            <span class="h6 regular mx2">Godkendt</span>
          </div>
        </div>
        <div class="col-4 px0 py1 flex justify-start">
          <el-input placeholder="Type something" v-model="search">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="py3"></div>
      <!-- contract table -->
      <div class="clearfix col-12 px3">
        <el-table :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"  stripe style="width: 100%">
          <el-table-column type="expand" label="Details" width="100">
            <template slot-scope="props">
              <div class="col-11 mx-auto py2 flex justify-start items-start">
                <div class="col-2 px2">
                  <p class="secondarycolor line-height-1 mb1">Type</p>
                  <p class="regular green">
                    {{props.row.type}}
                  </p>
                </div>
                <div class="col-3 px2">
                  <p class="secondarycolor line-height-1 mb1">Drafts</p>
                  <div class="flex justify-start items-center">
                    <a class="regular darkblue" href="">
                      <span class="mr1">Document Name.pdf</span>
                      <span><i class="el-icon-top-right"></i></span>
                    </a>
                  </div>
                </div>
                <div class="col-5 px2">
                  <p class="secondarycolor line-height-1 mb1">Beskrivelse</p>
                  <p class="regular darkblue line-height-3 p2 lightgrey-background">Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi ullam eligendi unde.</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="Date" width="180"></el-table-column>
          <el-table-column prop="name" label="Name" width="420"></el-table-column>
          <el-table-column prop="wallet" label="Wallet" width="200">
            <template slot-scope="props">
              <span class="semi-bold">{{props.row.wallet}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" prop="status" width="120">
            <template slot-scope="props">
              <b-alert class="p1 center regular line-height-1 m0 green-background white" show variant="success" v-if="props.row.status == 'Approved'">{{props.row.status}}</b-alert>
              <b-alert class="p1 center regular line-height-1 m0" show variant="warning" v-if="props.row.status == 'Pending'" style="background-color:#FFDD80;">{{props.row.status}}</b-alert>
              <b-alert class="p1 center regular line-height-1 m0" show variant="primary" v-if="props.row.status == 'Signed'" style="background-color:#54C4CB;color:#016A71;">{{props.row.status}}</b-alert>
              <b-alert class="p1 center regular line-height-1 m0 mutedxd muted-xd-border" show variant="light" v-if="props.row.status == 'Draft'">{{props.row.status}}</b-alert>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<style>
.modal-footer,
.modal-header {
  border-bottom: 0!important;
  border-top: 0!important;
}
.nav-tabs .nav-link.active,
.tab-content {
  border: 0;
}
.custom-control {
  margin-right: 0;
}
th > .cell {
  color: rgb(25, 163, 192);
  font-weight: 400;
}
.alert {
  border-radius: 1rem;
}
</style>


// WEBPACK FOOTER //
// contracts.vue?2c1b3653